import { GET_LOCATION_LIST, UPDATE_USER_LOCATION } from "./edit-hospital-location.query";

import { DASHBOARD } from "../dashboard/dashboard.query";
import { GET_ALL_PETS } from "../pet-list/pet-list.query";
import { GET_PROFILE } from "../user-detail/user-detail.query";
import { ILocationChangeResponse } from "./edit-hospital-location.interface";
import { ILocationUpdateInput } from "./edit-hospital-location.interface";
import { customIconsConfig } from "../../config/params";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";

export const useChangeLocation =() =>{
  const dispatch = useDispatch();
  const [updateUserLocation, { data, loading, error }] = useMutation<{updateUserLocation:
     ILocationChangeResponse}>(UPDATE_USER_LOCATION);


  const changeHospitalLocation = (data: ILocationUpdateInput) => {
    updateUserLocation({
      variables: { data },
      refetchQueries: [
        { query: GET_PROFILE },
        { query: DASHBOARD },
        { query: GET_ALL_PETS },
        { query: GET_LOCATION_LIST },
      ],
    });
  };

  useEffect(()=>{
    if (data?.updateUserLocation) {
      dispatch(toastMessageActions.setGlobalAlert({
        severity: "success",
        message: "Woohoo! Your Home Hospital has been successfully updated!",
        customIcon: customIconsConfig.SUCCESS_CELEBRATE_ICON,
      }));
    }
  }, [data?.updateUserLocation]);


  return {
    loading,
    changeHospitalLocation,
    updatedLocation: data?.updateUserLocation,
    error,
  };
};

export default useChangeLocation;

